"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdminImportCoursesController = /** @class */ (function () {
    function AdminImportCoursesController($state, $stateParams, FlashService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.FlashService = FlashService;
    }
    return AdminImportCoursesController;
}());
AdminImportCoursesController.$inject = [
    "$state",
    "$stateParams",
    "FlashService",
];
exports.default = AdminImportCoursesController;
